import { Box, useTheme, useMediaQuery } from "@mui/material";
import { ImageProps } from "./types";

export const Image = (props: ImageProps) => {
    const {
        src,
        alt,
        caption,
        width = "300px",
        height = "300px",
        objectFit = "cover",
        alignment = "center",
        borderRadius = "8px",
        shadow = false,
        url,
        target = "_blank",
        hoverEffect = true,
    } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const formattedUrl =
        url ?
            url.startsWith("http") ?
                url
            :   `https://${url}`
        :   undefined;

    const ImageComponent = (
        <Box
            component={formattedUrl ? "a" : "div"}
            href={formattedUrl}
            target={formattedUrl ? target : undefined}
            rel={formattedUrl && target === "_blank" ? "noopener noreferrer" : undefined}
            sx={{
                display: "block",
                width: isMobile ? "100%" : width,
                height: isMobile ? "auto" : height,
                maxWidth: "100%",
                borderRadius,
                overflow: "hidden",
                boxShadow: shadow ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
                cursor: formattedUrl ? "pointer" : "default",
                transition: formattedUrl && hoverEffect ? "transform 0.3s ease, opacity 0.3s ease" : "none",
                "&:hover":
                    formattedUrl && hoverEffect ?
                        {
                            transform: "scale(1.03)",
                            opacity: 0.9,
                        }
                    :   {},
            }}
        >
            <Box
                component="img"
                loading="lazy"
                src={src}
                alt={alt}
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit,
                    maxWidth: "100%",
                }}
            />
        </Box>
    );

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems:
                    alignment === "center" ? "center"
                    : alignment === "right" ? "flex-end"
                    : "flex-start",
            }}
        >
            {ImageComponent}
            {caption && (
                <Box
                    component="figcaption"
                    sx={{
                        mt: 1,
                        fontSize: "0.875rem",
                        color: "text.secondary",
                        textAlign: alignment,
                    }}
                >
                    {caption}
                </Box>
            )}
        </Box>
    );
};

Image.displayName = "Image";
